/* VELZEEN WebView capability gate. Classic syntax by design. */
(function (window, document) {
  'use strict';

  function addClass(element, name) {
    if (!element || !name) return;
    if (element.classList) element.classList.add(name);
    else if ((' ' + element.className + ' ').indexOf(' ' + name + ' ') === -1) element.className += (element.className ? ' ' : '') + name;
  }

  function supportsImportMaps() {
    try { return Boolean(window.HTMLScriptElement && window.HTMLScriptElement.supports && window.HTMLScriptElement.supports('importmap')); }
    catch (ignore) { return false; }
  }

  function supportsCssHas() {
    try { return Boolean(window.CSS && window.CSS.supports && window.CSS.supports('selector(:has(*))')); }
    catch (ignore) { return false; }
  }

  function supportsScrollOptions() {
    try {
      var accessed = false;
      var options = {};
      Object.defineProperty(options, 'top', { get: function () { accessed = true; return 0; } });
      window.scrollTo(options);
      return accessed;
    } catch (ignore) { return false; }
  }

  var probe = document.createElement('script');
  var capabilities = {
    modules: 'noModule' in probe,
    importMaps: supportsImportMaps(),
    customElements: Boolean(window.customElements && window.customElements.define),
    mutationObserver: typeof window.MutationObserver === 'function',
    intersectionObserver: typeof window.IntersectionObserver === 'function',
    resizeObserver: typeof window.ResizeObserver === 'function',
    abortController: typeof window.AbortController === 'function',
    dialog: Boolean(window.HTMLDialogElement && window.HTMLDialogElement.prototype && window.HTMLDialogElement.prototype.showModal),
    scrollOptions: supportsScrollOptions(),
    viewTransitions: typeof window.ViewTransition !== 'undefined' && ('onpageswap' in window || 'onpagereveal' in window),
    cssHas: supportsCssHas(),
    promise: typeof window.Promise === 'function',
    fetch: typeof window.fetch === 'function',
    map: typeof window.Map === 'function',
    set: typeof window.Set === 'function',
    proxy: typeof window.Proxy === 'function'
  };

  capabilities.enhanced = Boolean(
    capabilities.modules && capabilities.importMaps && capabilities.customElements &&
    capabilities.mutationObserver && capabilities.intersectionObserver && capabilities.abortController &&
    capabilities.dialog && capabilities.scrollOptions && capabilities.cssHas &&
    capabilities.promise && capabilities.fetch && capabilities.map && capabilities.set && capabilities.proxy
  );

  var ua = String((window.navigator && window.navigator.userAgent) || '');
  var html = document.documentElement;
  addClass(html, 'vz-webview-guard');
  if (/Instagram|FBAN|FBAV|FB_IAB|Line\//i.test(ua)) addClass(html, 'vz-in-app-webview');
  if (!capabilities.enhanced) addClass(html, 'vz-webview-limited');
  if (!capabilities.dialog) addClass(html, 'vz-no-dialog');
  if (!capabilities.viewTransitions) addClass(html, 'vz-no-view-transitions');
  if (!capabilities.cssHas) addClass(html, 'vz-no-css-has');

  function safeScrollTo(element, options) {
    if (!element || typeof element.scrollTo !== 'function') return;
    try { element.scrollTo(options); }
    catch (ignore) {
      try {
        element.scrollLeft = options && typeof options === 'object' ? Number(options.left || 0) : Number(options || 0);
        element.scrollTop = options && typeof options === 'object' ? Number(options.top || 0) : 0;
      } catch (ignoreAgain) {}
    }
  }

  window.VelzeenWebview = window.VelzeenWebview || {};
  window.VelzeenWebview.version = '1.0.0';
  window.VelzeenWebview.capabilities = capabilities;
  window.VelzeenWebview.supportPolicy = {
    enhancedIOS: 'iOS Safari / WKWebView 16.4+',
    enhancedAndroid: 'Android Chrome / Android System WebView 105+',
    fallback: 'Server-rendered PDP with optional enhancements disabled locally'
  };
  window.VelzeenWebview.testMatrix = ['Android Instagram', 'Android Facebook', 'iOS Instagram', 'Chrome Android', 'Safari iOS'];
  window.VelzeenWebview.safeScrollTo = safeScrollTo;

  if (!capabilities.viewTransitions) {
    var blocker = document.getElementById('view-transition-render-blocker');
    if (blocker && blocker.parentNode) blocker.parentNode.removeChild(blocker);
  }
})(window, document);
